export interface IExternal_Mappings {
    id: string;
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    charge_code: string;
    description: string;
    created_by?: string;
    updated_by?: string;
    app_name: any
}

export class External_Mappings implements IExternal_Mappings {
    id: string;
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    charge_code: string;
    description: string;
    created_by?: string;
    updated_by?: string;
    app_name: any;

    mapErr: any;

    constructor() {
        this.id = null;
        this.updated_at = null;
        this.created_at = null;
        this.is_active = true;
        this.charge_code = null;
        this.description = null;
        this.created_by = null;
        this.updated_by = null;
        this.app_name = null;

        this.resetMapError();
    }

    resetMapError() {
        this.mapErr = {
            app_name: [],
            charge_code: [],
            description: [],
        }
    }

    savePayloadToModel(data) {
        this.id = data.id;
        this.updated_at = data.updated_at;
        this.created_at = data.created_at;
        this.is_active = data.is_active;
        this.charge_code = data.charge_code;
        this.description = data.description;
        this.created_by = data.created_by;
        this.updated_by = data.updated_by;
        this.app_name = data.app_name;
    }

    getPostPayload() {
        return {
            id: this.id,
            is_active: this.is_active,
            charge_code: this.charge_code,
            description: this.description,
            app_name: typeof this.app_name == 'object' && this.app_name != null ? this.app_name.id : this.app_name,
        }
    }

    checkMapErrors() {
        return this.mapErr.app_name.length == 0
            && this.mapErr.charge_code.length == 0
            && this.mapErr.description.length == 0
    }

    setMappingErrors(err) {
        this.mapErr.app_name = err.app_name?.length ? err.app_name : [];
        this.mapErr.charge_code = err.charge_code?.length ? err.charge_code : [];
        this.mapErr.description = err.description?.length ? err.description : [];
    }
}